import { STORE_MERCHANT_SCROLL } from "../../database/store-names";
import { GET_SET_STORED_DATA } from "../../database/get-stored-data";
import { ENCRYPT_STORAGE } from "../../config/config";
import { dto_Customer } from "../../classes/dto-customer";
import ORDERVIEW from "./components/orders-view/pg-orders-view";
import React from "react";

export default class Order extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      GUID: 0,
      CSID: 0,
      IsReady: false,
    };
  }

  async componentDidMount() {
    await GET_SET_STORED_DATA();
    this.setState({
      CSID: dto_Customer.CSID,
      IsReady: true
    });
    ENCRYPT_STORAGE.removeItem(STORE_MERCHANT_SCROLL);
  }

  render() {
    return (
      <div>
        {this.state.IsReady === true ? (
          <ORDERVIEW CSID={this.state.CSID} navigate={this.props.navigate} />
        ) : null}
      </div>
    );
  }
}